import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-ai-connections-skeleton',
  templateUrl: './ai-connections-skeleton.component.html',
  styleUrls: ['./ai-connections-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class AiConnectionsSkeletonComponent {
  readonly tableRows = [1, 2, 3, 4, 5];
  readonly tableCols = [1, 2, 3, 4, 5, 6];
}